import { Popover, Typography } from "antd";
const { Paragraph } = Typography;

const ParagraphPopup = ({ title, text, rows, maxWidth }) => {
  return (
    <Popover
      content={
        <div className="pop-paragraph-container">
          <Paragraph className="line-break fontSmall">{text}</Paragraph>
        </div>
      }
      title={title}>
      <Paragraph
        className="line-break fontSmall"
        style={{ width: maxWidth ?? "auto" }}
        ellipsis={{
          rows: rows ?? 2,
          expandable: false,
        }}>
        {text}
      </Paragraph>
    </Popover>
  );
};

export { ParagraphPopup };
